module.exports = __webpack_public_path__ + "static/media/lombardia_permuy_gibbons.d0e67c72.jpg";